module.exports = __webpack_public_path__ + "static/media/medical-file.5908ce40.svg";